import {get, post} from "services/BaseClient/Client"
import endPoints from "./EndPoints"
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";




export const addFeedbackByUser = async (data: any): Promise<DataResponse<any>> => {
    const url = `${endPoints.addFeedbackByUser}`;
    const config = headers.content_type.application_json;
    return post<DataResponse<any>>(url, data, config);
  };

  export const addMediaByFeedback= async (data: any): Promise<DataResponse<any>> => {
    const url = `${endPoints.addMediaByFeedback}`;
    const config = headers.content_type.multipart_form_data;
    return post<DataResponse<any>>(url, data, config);
  };

  export const getFeedbackListByUser= async (): Promise<DataResponse<any>> => {
    const url = `${endPoints.getFeedbackListByUser}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };

  export const getFeedbackCategoryList = async (): Promise<DataResponse<any>> => {
    const url = `${endPoints.getFeedbackCategoryList}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };

  